import { render, staticRenderFns } from "./ImageContainer.vue?vue&type=template&id=edcdd6d2&scoped=true"
import script from "./ImageContainer.vue?vue&type=script&lang=js"
export * from "./ImageContainer.vue?vue&type=script&lang=js"
import style0 from "./ImageContainer.vue?vue&type=style&index=0&id=edcdd6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcdd6d2",
  null
  
)

export default component.exports